var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.999,
    height: 77,
    viewBox: "0 0 65.999 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M4.188,0l2.45,4.42L14.758.053,17,4.332,6.821,9.888,4.788,11l-.078-.021L3.552,8.83,0,2.357Z",
    transform: "translate(25 39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    d: "M47.948,77h0a2.3,2.3,0,0,1-.681-.1L1.625,62.737A2.321,2.321,0,0,1,.1,59.841L15.835,8.558a2.222,2.222,0,0,1,2.152-1.653,2.209,2.209,0,0,1,.728.123l6.9,2.14.5-1.624a2.3,2.3,0,0,1,2.88-1.53l4.841,1.5a7.04,7.04,0,0,1,.362-1.179,9.3,9.3,0,1,1,17.6,6.025l-.2.662,4.841,1.5a2.321,2.321,0,0,1,1.522,2.9l-.5,1.624,6.9,2.139A2.251,2.251,0,0,1,65.743,22.3a2.276,2.276,0,0,1,.135,1.781L50.146,75.365A2.291,2.291,0,0,1,47.948,77ZM32.276,28.765A15.441,15.441,0,0,0,17.528,39.712a15.707,15.707,0,0,0,1.105,11.827,15.408,15.408,0,0,0,28.393-2.676,15.5,15.5,0,0,0-1.1-11.83,15.409,15.409,0,0,0-13.646-8.268ZM29.834,11.124h0L28.612,15.11l23.042,7.145,1.222-3.983-2.642-.82a4.633,4.633,0,0,1-2.8-2.4,4.922,4.922,0,0,1-.131-3.759l.09-.293a4.6,4.6,0,0,0-.325-3.658,4.861,4.861,0,0,0-2.9-2.351A4.742,4.742,0,0,0,38.53,7.922l-.2.666a4.756,4.756,0,0,1-2.119,2.979,4.877,4.877,0,0,1-3.731.376l-2.641-.819Z",
    transform: "translate(0 0)",
    fill: "#444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.84448652ce994be9c45b7a5750fc6e21.svg";
export { ForwardRef as ReactComponent };